import React from "react";

import { numberToLocaleString } from "../../../../../helpers/Utils";
import AppConfig from "../../../../../AppConfig";

export default function ProductPrice({ product, className = "" }) {
	return (
		<div className={className}>
			{numberToLocaleString(product.price)}
			{["NFT-Gated", "Free"].includes(product.price) ? null : (
				<span> {AppConfig.currency}</span>
			)}
		</div>
	);
}
